import React from 'react';
import { useWorldStore } from '../state/worldStore';
import useDjBillboard from '../hooks/useDjBillboard';

// DjBillboardHost — mounts the radio DJ video-host cameo machine and the hidden
// <video> its Anam stream binds to. The stream's PIXELS get sampled onto the big
// city billboards by CityBillboards (VideoTexture); its AUDIO plays from this
// element (the station music ducks under it). Element must exist in the DOM
// before the SDK's streamToVideoElement runs, so it's always rendered — just
// parked off-screen. ?dj shows a tiny state pill for testing (press "v" to fire
// a cameo now).
const DEV = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('dj') != null;

const hidden = {
  position: 'fixed', left: -9999, top: 0, width: 2, height: 2,
  opacity: 0, pointerEvents: 'none',
};
const pill = (live) => ({
  position: 'fixed', left: 16, bottom: 'max(16px, env(safe-area-inset-bottom))', zIndex: 45,
  padding: '7px 12px', borderRadius: 999, font: '600 12px system-ui, sans-serif',
  color: live ? '#1c1206' : '#ffe9c4', background: live ? '#ffb25e' : 'rgba(16,10,6,0.8)',
  border: '1px solid rgba(255,178,94,0.4)', backdropFilter: 'blur(8px)', pointerEvents: 'none',
});

export default function DjBillboardHost() {
  useDjBillboard();
  const { phase, hostName } = useWorldStore((s) => s.djCameo);

  return (
    <>
      {/* Not muted: the DJ's voice plays from here while the billboards show the
          picture. playsInline + autoPlay so the SDK can start it on gesture. */}
      <video id="dj-cameo-video" autoPlay playsInline style={hidden} />
      {DEV && (
        <div style={pill(phase === 'live')}>
          🎙 DJ cam · {phase}{hostName ? ` · ${hostName.split(' ')[0]}` : ''}{phase === 'armed' ? ' · press v' : ''}
        </div>
      )}
    </>
  );
}
